<template>
<div>
  <el-tabs type="border-card" v-model="activeName" @tab-click="reset">
    <el-tab-pane label="旧密码修改" name="byOldPsw">
      <update-psw-by-old-psw :key="'v_' + viewKey" @cancel="dismiss" @success="dismiss"/>
    </el-tab-pane>
    <el-tab-pane label="短信验证码修改" name="bySmsCode">
      <update-by-sms-code :key="'n_' + viewKey" @cancel="dismiss" @success="dismiss"/>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import UpdatePswByOldPsw from './updatePswByOldPsw'
import UpdateBySmsCode from './updateBySmsCode'
export default {
  name: 'updatePsw',
  components: {UpdateBySmsCode, UpdatePswByOldPsw},
  data () {
    return {
      activeName: 'byOldPsw',
      viewKey: -1000000
    }
  },
  methods: {
    reset () {
      this.viewKey = this.viewKey + 1
    },
    dismiss () {
      this.$emit('dismiss')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login/updatePsw.vue